import {connect} from 'react-redux';

import {makeMapStateToProps} from '../../../../helpers/reselectHelpers';
import {getAttachmentActionIntegrations} from '../../../../store/data/dataSelectors';
import {
  CalendarAttachmentsButtonCoordinator,
  CalendarAttachmentsButtonCoordinatorPublicProps,
} from './calendarAttachmentsButtonCoordinator';

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<CalendarAttachmentsButtonCoordinatorPublicProps>()(() => ({
  integrations: getAttachmentActionIntegrations,
}));

export const CalendarAttachmentsButtonCoordinatorContainer = connect(mapStateToProps)(
  CalendarAttachmentsButtonCoordinator,
);
